// window.onload = function() {
//     setTimeout(() => {
//         const checkoutButton = document.querySelector('.cart-drawer__checkout-buttons button');
//         const subtotalSpan = document.querySelector('.cart-drawer__checkout-buttons .bss-qb-cart-subtotal');

//         if (checkoutButton && subtotalSpan) {
//             checkoutButton.appendChild(subtotalSpan);
//         }
//     }, 2000);
// };

window.addEventListener("cart_changed", () => {
  BSS_B2B.cart.fixer(JSON.parse($("#bss-b2b-store-data").html()), false, false);
});

window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
function fixQueryArrInQbCartSubtotalPriceElement({ queryArr }) {
    if ($("[bss-b2b-cart-total-price]").length > 0) {
        queryArr = ['[bss-b2b-cart-total-price]'];
    }
    return queryArr;
}
window.BSS_B2B.addFilter('fix_queryArr_in_qb_cartSubtotalPriceElement', fixQueryArrInQbCartSubtotalPriceElement);